import {animate, state, style, transition, trigger} from '@angular/animations';
import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {RouterLink, RouterLinkActive} from '@angular/router';

@Component({
    standalone: true,
    imports: [RouterLink, RouterLinkActive],
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'nav-logo',
    templateUrl: './nav-logo.component.html',
    styleUrls: ['./nav-logo.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('expandCollapse', [
            state('expand', style({width: '*'})),
            state('collapse', style({width: '55px'})),
            transition('expand => collapse', [animate('350ms')]),
            transition('collapse => expand', [animate('350ms')])
        ])
    ]
})
export class NavLogoComponent {
    isApex = input<boolean>(false);
    isMedality = input<boolean>(false);
    isComquest = input<boolean>(false);
    expanded = input<boolean>(true);

    animationState = computed(() => (this.expanded() ? 'expand' : 'collapse'));
}
